/* Example use:
<tabs-component>
  <div class="tabs">
    <button data-active="true" data-tab-control="cm">
      CM
    </button>
    <button data-tab-control="inch">INCH</button>
  </div>

  <div class="panel" data-active="true" data-panel-id="cm">
    1
  </div>
  <div class="panel" data-panel-id="inch">
    2
  </div>
</tabs-component>;
*/

class TabsComponent extends HTMLElement {
  constructor() {
    super();

    this.tabControls = this.querySelectorAll('[data-tab-control]');
    this.panels = this.querySelectorAll('[data-panel-id]');

    this.setupEventListeners();
    this.updateActiveTable();
  }

  setupEventListeners() {
    if (this.tabControls) {
      this.tabControls.forEach((tabControl) => {
        tabControl.addEventListener('click', this.updateActiveTable.bind(this));
      });
    }
  }

  updateActiveTable(e) {
    if (!e || !e?.target) return;
    const selectedTab = e.target.dataset.tabControl;

    this.panels.forEach((panel) => {
      const match = panel.dataset.panelId === selectedTab;
      panel.dataset.active = match;
    });

    this.tabControls.forEach((tabControl) => {
      tabControl.dataset.active = tabControl.dataset.tabControl === selectedTab;
    });
  }
}

customElements.define('tabs-component', TabsComponent);
